import React, { FunctionComponent } from "react";
import "./style.scss";
import bubble_img from "../../asserts/svg/bubble.svg";

const PriceBlock: FunctionComponent = () => {
    return <div id="pricign" className="PriceBlock">
        <div className="content">
            <h1>Messengers</h1>
            <div className="tile">
                <div className="icon">
                    <img src={bubble_img} alt="bubble" />
                </div>
                <div className="buttons">
                    <a target="_blank"  rel="noreferrer" href="https://processing.timinator.app/slack/install">
                        <button>
                            <div className="image"/>
                            <div className="text">Add to Slack</div>
                        </button>
                    </a>
                    <a target="_blank"  rel="noreferrer" href="https://t.me/timinator_bot">
                        <button>
                            <div className="imageTg"/>
                            <div className="text">Add to Telegram</div>
                        </button>
                    </a>
                    <button disabled>
                        <div className="imageTeams"/>
                        <div className="text">Teams coming soon</div>
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export default PriceBlock;